module.exports = __webpack_public_path__ + "img/c2.70ca2cc4.png";